import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faThumbsDown, faEllipsis, faCloudDownload, faCheckCircle, faExclamationCircle, faEye, faRefresh } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";
import ExportPopup from './orderExport'
import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { orderList,changeOrderStatus, reverseOrderCancel } from "../../../controllers/V1/cms/campaignController";
import { getPage } from "../../../controllers/common";
import { formatProjectDate } from "../../../controllers/common";
import { usePermissions } from "../../../controllers/PermissionContext";
import ConfirmPopup from "../../../components/ConfirmPopup";
import ConfirmReverseCancelPopup from "./ConfirmReverseCancelPopup";
import Loading from "../../../components/Loading/LoadingEffect";
import { statusMessage } from "../../../controllers/common";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("campaignOrder");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportOrder = () => setExportShow(!isExportShow);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const toggleConfirmPopup = () => setConfirmPopup(!confirmPopup);
  const [cancelID, setCancelID] = useState('');

  const [reverseConfirmPopup, setReverseConfirmPopup] = useState(false);
  const toggleReverseConfirmPopup = () => setReverseConfirmPopup(!reverseConfirmPopup);
  const [reverseCancelID, setReverseCancelID] = useState('');

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [totalDataCount, setTotalDataCOunt] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedAt, setAppliedAt] = useState(0);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "order_no",
    search: "CKING",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [fromDate, setFromDate] = useState(`${moment().subtract(1,'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...((filter?.filter_by === 'order_no' && filter?.search !== 'CKING')?{ order_no: { $regex: filter?.search, $options: "i" }} : null),
          ...(filter?.filter_by === 'pin'?{ pin : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'campaign_title'?{campaign_title : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'seller_first_name'?{seller_first_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'seller_last_name'?{seller_last_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'seller_mobile'?{seller_mobile : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'seller_pos_number'?{seller_pos_number : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'is_print'?{is_print : filter?.search }:null),
          ...(filter?.filter_by === 'status'?{status : { $regex: filter?.search, $options: "i" } }:null),
          
          ...(filter?.from?{createdAt : {$gte : filter.from, $lte : filter.to} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await orderList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalDataCOunt(listData?.count);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      setFromDate("");
      setToDate("");
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const to = moment(form.get('to_date')).format('YYYY-MM-DD HH:mm:ss')
      const from = moment(form.get('from_date')).format('YYYY-MM-DD HH:mm:ss')
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') ? moment(to).format('YYYY-MM-DD HH:mm:ss') : '',
        'from'      : form.get('from_date') ? moment(from).format('YYYY-MM-DD HH:mm:ss') : ''

      }))
      // getList();
      handleFiterDrawer();
      setSkip(0);
      setAppliedAt((n) => n + 1);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || Order's list";
  }, [currentPage, showRequest, LIMIT, appliedAt]);


  useEffect(()=>{
  },[])

  const handleViewDetails = (items) => {
    navigate('/campaign/order/details', { state: items });
  }

  const handleChangeStatus = async (id = '', status = 'Cancel') =>{
    try {
      setIsLoading(true);
      if(!cancelID){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
      } else if(!status){
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
      } else {
        const option ={ order_id : cancelID, status : status };
        const res = await changeOrderStatus(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `User updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleReverseOrderCancellation = async (id = '') =>{
    try {
      setIsLoading(true);
      if(!reverseCancelID){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
      } else {
        const option = { order_id : reverseCancelID };
        const res = await reverseOrderCancel(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Order cancellation reversed successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleFilterChange = (e) =>{
    const {name, value} = e.target;
    if(name === 'filter_by' && value === 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : 'CKING'
      }))
    } else if(name === 'filter_by' && value !== 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : ''
      }))
    } else if(name === 'from_date'){
      setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else if(name === 'to_date'){
      setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else {
      setFilter((pre)=>({
        ...pre,
        [name] : value
      }))
    }
  }

  const handleRefreshPage = () => {
    try {
      setFilter({});
      getList();
    } catch (error) {
      
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Order's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setCurrentPage(1);
                        setShowRequest("")
                      }}
                    />

                    <Tab
                      label="Success"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setCurrentPage(1);
                        setShowRequest("Success")
                      }}
                    />
                    <Tab
                      label="Canceled"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setCurrentPage(1);
                        setShowRequest("Cancel")
                      }}
                    />
                    <Tab
                      label="Pending"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setCurrentPage(1);
                        setShowRequest("Pending")
                      }}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main " style={{paddingRight:"2%"}}>
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleExportOrder}>
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                  )}
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>handleRefreshPage()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >

              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Order No.</th>
                              <th>Campaign Title</th>
                              <th>Seller Details</th>
                              <th>Straight</th>
                              <th>Rumble</th>
                              <th>Chance</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                              <th>Action</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA?.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.order_no}</td>
                                    <td>{items?.campaign_title}</td>
                                     <td>Name: {`${items?.seller_first_name} ${items?.seller_last_name}`}<br/> Mob: {items?.seller_mobile} <br/> Pos: {items?.seller_pos_number} <br/> Type: {items?.seller_user_id?.users_type} </td>
                                    <td>Points: {`${items?.straight?.points??0}`}<br/> Qty: {items?.straight?.qty??0} <br/> Total: {items?.straight?.total_points??0} </td>
                                    <td>Points: {`${items?.rumble?.points??0}`}<br/> Qty: {items?.rumble?.qty??0} <br/> Total: {items?.rumble?.total_points??0} </td> 
                                    <td>Points: {`${items?.chance?.points??0}`}<br/> Qty: {items?.chance?.qty??0} <br/> Total: {items?.chance?.total_points??0} </td>
                                    <td>{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY HH:mm:ss')}</td>
                                    {items?.status === 'Cancel' ? (
                                      <td>
                                        <span className="text-danger">{items?.status}</span> <br/>
                                        <span className="text-danger">{items?.remarks || '--'}</span>
                                      </td>
                                    ):(
                                      <td dangerouslySetInnerHTML={{__html: statusMessage(items?.status)}}></td>
                                    )}
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.view === 'Y') && (
                                              <Menu.Item key={`1`} onClick={() => { handleViewDetails(items) }} >
                                                <FontAwesomeIcon icon={faEye} /> <span className="show_span">View</span>
                                              </Menu.Item>
                                            )}
                                            {(items.status === "Success" && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.changeStatus === 'Y')) && (
                                              <Menu.Item key={`3`} onClick={() => {
                                                setCancelID(items._id)
                                                toggleConfirmPopup();
                                                // handleChangeStatus(items._id,'Cancel')
                                                }} >
                                                <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Cancel</span>
                                              </Menu.Item>
                                            )}
                                             {((PERMISSION?.fullAccess === 'Y' || PERMISSION?.view === 'Y') && items.status === "Cancel") && (
                                              <Menu.Item key={`2`} onClick={() => { 
                                                  setReverseCancelID(items._id)
                                                  toggleReverseConfirmPopup(); 
                                                }} >
                                                <FontAwesomeIcon icon={faRefresh} /> <span className="show_span">Reverse Order Cancellation</span>
                                              </Menu.Item>
                                            )}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={10} /> : <tr> 
                                <td colspan="10" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <p>{`${SKIP + 1} - ${totalDataCount > LIMIT ? LIMIT * currentPage : totalDataCount} of ${totalDataCount}`}</p>
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
            <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportOrder} />
          </Box>
        </div>
      </div>
      
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" onChange={handleFilterChange} ref={inputRef1}>
                  <option value='' selected disabled>Select search field</option>
                  <option value='order_no' selected={filter?.filter_by ==='order_no'?true:false}>Order number</option>
                  <option value='pin' selected={filter?.filter_by ==='pin'?true:false}>Order Pin</option>
                  <option value='campaign_title' selected={filter?.filter_by ==='campaign_title'?true:false}>Campaign Title</option>
                  <option value='seller_first_name' selected={filter?.filter_by ==='seller_first_name'?true:false}>Seller First Name</option>
                  <option value='seller_last_name' selected={filter?.filter_by ==='seller_last_name'?true:false}>Seller Last Name</option>
                  <option value='seller_mobile' selected={filter?.filter_by ==='seller_mobile'?true:false}>Seller Mobile</option>
                  <option value='seller_pos_number' selected={filter?.filter_by ==='seller_pos_number'?true:false}>Seller Pos</option>
                  <option value='is_print' selected={filter?.filter_by ==='is_print'?true:false}>Invoice Print (Y/N)</option>
                  <option value='status' selected={filter?.filter_by ==='status'?true:false}>Status</option>
                </select>
              </div>
              {["pin","seller_pos_number","seller_mobile"].includes(filter?.filter_by) && (
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                    Search Text :
                  </label>
                  <input
                    title="Enter search text."
                    placeholder="Enter search text."
                    type="number"
                    name="search"
                    value={filter?.search}
                    className="form-control store_input_field"
                    id="search"  
                    ref={inputRef2}
                    onChange={handleFilterChange}
                  />
                </div>
              )}

              {["status"].includes(filter?.filter_by) && (
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                    Select :
                  </label>
                  <select
                    name="search"
                    className="form-control store_input_field"
                    id="search"  
                    ref={inputRef2}
                    onChange={handleFilterChange}
                  >
                    <option value="" >Select any option</option>
                    <option value="Pending" selected={filter?.search === "Pending"} >Pending</option>
                    <option value="Cancel" selected={filter?.search === "Cancel"} >Cancelled</option>
                    <option value="Success" selected={filter?.search === "Success"} >Success</option>
                  </select>
                </div>
              )}

              {["is_print"].includes(filter?.filter_by) && (
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                    Select :
                  </label>
                  <select
                    name="search"
                    className="form-control store_input_field"
                    id="search"  
                    ref={inputRef2}
                    onChange={handleFilterChange}
                  >
                    <option value="" >Select any option</option>
                    <option value="Y" selected={filter?.search === "Y"} >Yes</option>
                    <option value="N" selected={filter?.search === "N"} >No</option>
                  </select>
                </div>
              )}

              {["order_no", "campaign_title", "seller_first_name", "seller_last_name"].includes(filter?.filter_by) && (
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                    Search Text :
                  </label>
                  <input
                    title="Enter search text."
                    placeholder="Enter search text."
                    type="text"
                    name="search"
                    value={filter?.search}
                    className="form-control store_input_field"
                    id="search"  
                    ref={inputRef2}
                    onChange={handleFilterChange}
                  />
                </div>
              )}
              
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <ConfirmPopup popUpOpen={confirmPopup} togglePopUp={toggleConfirmPopup} process={handleChangeStatus} />
      <ConfirmReverseCancelPopup popUpOpen={reverseConfirmPopup} togglePopUp={toggleReverseConfirmPopup} process={handleReverseOrderCancellation} />
      <Loading isLoading={isLoading} />
    </>
  );
}
